// @flow

// Auth Actions
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';

// Sketch Orders Actions
export const GET_SKETCH_ORDERS_REQUEST = 'GET_SKETCH_ORDERS_REQUEST';
export const GET_SKETCH_ORDERS_SUCCESS = 'GET_SKETCH_ORDERS_SUCCESS';
export const GET_SKETCH_ORDERS_FAILURE = 'GET_SKETCH_ORDERS_FAILURE';

// Sketch Order Dashboard Actions
export const GET_ALL_SKETCH_ORDER_COUNTS_REQUEST = 'GET_ALL_SKETCH_ORDER_COUNTS_REQUEST';
export const GET_ALL_SKETCH_ORDER_COUNTS_SUCCESS = 'GET_ALL_SKETCH_ORDER_COUNTS_SUCCESS';
export const GET_ALL_SKETCH_ORDER_COUNTS_FAILURE = 'GET_ALL_SKETCH_ORDER_COUNTS_FAILURE';
export const UPDATE_ALL_SKETCH_ORDER_COUNTS = 'UPDATE_ALL_SKETCH_ORDER_COUNTS'

// Current User Actions
export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';

// Current User Roles Actions
export const GET_CURRENT_USER_ROLES_REQUEST = 'GET_CURRENT_USER_ROLES_REQUEST';
export const GET_CURRENT_USER_ROLES_SUCCESS = 'GET_CURRENT_USER_ROLES_SUCCESS';
export const GET_CURRENT_USER_ROLES_FAILURE = 'GET_CURRENT_USER_ROLES_FAILURE';

// Organizations Actions
export const GET_ORGANIZATIONS_REQUEST = 'GET_ORGANIZATIONS_REQUEST';
export const GET_ORGANIZATIONS_SUCCESS = 'GET_ORGANIZATIONS_SUCCESS';
export const GET_ORGANIZATIONS_FAILURE = 'GET_ORGANIZATIONS_FAILURE';

// User Profiles Actions
export const GET_USER_PROFILES_REQUEST = 'GET_USER_PROFILES_REQUEST';
export const GET_USER_PROFILES_SUCCESS = 'GET_USER_PROFILES_SUCCESS';
export const GET_USER_PROFILES_FAILURE = 'GET_USER_PROFILES_FAILURE';

// Sketch Order Actions
export const GET_SKETCH_ORDER_REQUEST = 'GET_SKETCH_ORDER_REQUEST';
export const GET_SKETCH_ORDER_SUCCESS = 'GET_SKETCH_ORDER_SUCCESS';
export const GET_SKETCH_ORDER_FAILURE = 'GET_SKETCH_ORDER_FAILURE';
export const UPDATE_SKETCH_ORDER_REQUEST = 'UPDATE_SKETCH_ORDER_REQUEST';
export const UPDATE_SKETCH_ORDER_SUCCESS = 'UPDATE_SKETCH_ORDER_SUCCESS';
export const UPDATE_SKETCH_ORDER_FAILURE = 'UPDATE_SKETCH_ORDER_FAILURE';
export const DELETE_SKETCH_ORDER_PROJECT_REQUEST = 'DELETE_SKETCH_ORDER_PROJECT_REQUEST';
export const DELETE_SKETCH_ORDER_PROJECT_SUCCESS = 'DELETE_SKETCH_ORDER_PROJECT_SUCCESS';
export const DELETE_SKETCH_ORDER_PROJECT_FAILURE = 'DELETE_SKETCH_ORDER_PROJECT_FAILURE';

// Sketch Order Tiers Actions
export const GET_SKETCH_ORDER_TIERS_REQUEST = 'GET_SKETCH_ORDER_TIERS_REQUEST';
export const GET_SKETCH_ORDER_TIERS_SUCCESS = 'GET_SKETCH_ORDER_TIERS_SUCCESS';
export const GET_SKETCH_ORDER_TIERS_FAILURE = 'GET_SKETCH_ORDER_TIERS_FAILURE';

// User Profile Actions
export const GET_USER_PROFILE_REQUEST = 'GET_USER_PROFILE_REQUEST';
export const GET_USER_PROFILE_SUCCESS = 'GET_USER_PROFILE_SUCCESS';
export const GET_USER_PROFILE_FAILURE = 'GET_USER_PROFILE_FAILURE';

// Organization Actions
export const GET_ORGANIZATION_REQUEST = 'GET_ORGANIZATION_REQUEST';
export const GET_ORGANIZATION_SUCCESS = 'GET_ORGANIZATION_SUCCESS';
export const GET_ORGANIZATION_FAILURE = 'GET_ORGANIZATION_FAILURE';

// Sketch Host Actions
export const SHOW_SKETCH = 'SHOW_SKETCH';
export const HIDE_SKETCH = 'HIDE_SKETCH';

// Project Actions
export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';
export const GET_PROJECT_FAILURE = 'GET_PROJECT_FAILURE';

// Sketch Tech User Profiles Actions
export const GET_SKETCH_TECH_USER_PROFILES_REQUEST = 'GET_SKETCH_TECH_USER_PROFILES_REQUEST';
export const GET_SKETCH_TECH_USER_PROFILES_SUCCESS = 'GET_SKETCH_TECH_USER_PROFILES_SUCCESS';
export const GET_SKETCH_TECH_USER_PROFILES_FAILURE = 'GET_SKETCH_TECH_USER_PROFILES_FAILURE';

// Orders Tabs Actions
export const SET_ACTIVE_ORDERS_TAB = 'SET_ACTIVE_ORDERS_TABS';

// Search Sketch Orders Actions
export const GET_SEARCH_SKETCH_ORDERS_REQUEST = 'GET_SEARCH_SKETCH_ORDERS_REQUEST';
export const GET_SEARCH_SKETCH_ORDERS_SUCCESS = 'GET_SEARCH_SKETCH_ORDERS_SUCCESS';
export const GET_SEARCH_SKETCH_ORDERS_FAILURE = 'GET_SEARCH_SKETCH_ORDERS_FAILURE';

// Search Suggestions Actions
export const GET_SEARCH_SUGGESTIONS_REQUEST = 'GET_SEARCH_SUGGESTIONS_REQUEST';
export const GET_SEARCH_SUGGESTIONS_SUCCESS = 'GET_SEARCH_SUGGESTIONS_SUCCESS';
export const GET_SEARCH_SUGGESTIONS_FAILURE = 'GET_SEARCH_SUGGESTIONS_FAILURE';
export const CLEAR_SEARCH_SUGGESTIONS = 'CLEAR_SEARCH_SUGGESTIONS';

// Project Drawing Summary Actions
export const GET_PROJECT_DRAWING_SUMMARY_REQUEST = 'GET_PROJECT_DRAWING_SUMMARY_REQUEST';
export const GET_PROJECT_DRAWING_SUMMARY_SUCCESS = 'GET_PROJECT_DRAWING_SUMMARY_SUCCESS';
export const GET_PROJECT_DRAWING_SUMMARY_FAILURE = 'GET_PROJECT_DRAWING_SUMMARY_FAILURE';

// Notification template actions
export const GET_NOTIFICATION_TEMPLATES_REQUEST = 'GET_NOTIFICATION_TEMPLATES_REQUEST';
export const GET_NOTIFICATION_TEMPLATES_SUCCESS = 'GET_NOTIFICATION_TEMPLATES_SUCCESS';
export const GET_NOTIFICATION_TEMPLATES_FAILURE = 'GET_NOTIFICATION_TEMPLATES_FAILURE';

// Sketch order notification actions
export const CREATE_SKETCH_ORDER_NOTIFICATION_REQUEST = 'CREATE_SKETCH_ORDER_NOTIFICATION_REQUEST';
export const CREATE_SKETCH_ORDER_NOTIFICATION_SUCCESS = 'CREATE_SKETCH_ORDER_NOTIFICATION_SUCCESS';
export const CREATE_SKETCH_ORDER_NOTIFICATION_FAILURE = 'CREATE_SKETCH_ORDER_NOTIFICATION_FAILURE';

export const UPDATE_SKETCH_ORDER_NOTIFICATION_REQUEST = 'UPDATE_SKETCH_ORDER_NOTIFICATION_REQUEST';
export const UPDATE_SKETCH_ORDER_NOTIFICATION_SUCCESS = 'UPDATE_SKETCH_ORDER_NOTIFICATION_SUCCESS';
export const UPDATE_SKETCH_ORDER_NOTIFICATION_FAILURE = 'UPDATE_SKETCH_ORDER_NOTIFICATION_FAILURE';

// Sketch orders notifications actions
export const GET_SKETCH_ORDER_NOTIFICATIONS_REQUEST = 'GET_SKETCH_ORDER_NOTIFICATIONS_REQUEST';
export const GET_SKETCH_ORDER_NOTIFICATIONS_SUCCESS = 'GET_SKETCH_ORDER_NOTIFICATIONS_SUCCESS';
export const GET_SKETCH_ORDER_NOTIFICATIONS_FAILURE = 'GET_SKETCH_ORDER_NOTIFICATIONS_FAILURE';
